/**
 * Application version management
 * 
 * Increment this version number whenever you make significant changes
 * to the application that should trigger a cache refresh for users.
 * 
 * Follows semantic versioning:
 * - MAJOR: Breaking changes that require cache invalidation
 * - MINOR: New features that might need cache refresh
 * - PATCH: Bug fixes that don't necessarily require cache refresh
 */

export const APP_VERSION = '1.1.6';